import { LocationEntity } from "@src/core/entities";
import { trackError } from "@src/core/sentry";
import { getGeocode } from "use-places-autocomplete";

export const getLocationFromCoordinates = async (
  lat: number,
  lng: number,
): Promise<LocationEntity | undefined> => {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

  try {
    const addressList = await getGeocode({ location: { lat, lng } });
    const first = addressList?.[0];
    if (!first?.formatted_address) return;

    return {
      latitude: lat,
      longitude: lng,
      address: first.formatted_address,
    };
  } catch (error: unknown) {
    trackError(error instanceof Error ? error : new Error(String(error)), {
      code: 'FE_0007',
      extra: { lat, lng },
    });
    return undefined;
  }
};

export const getLocationFromMap = async (e: google.maps.MapMouseEvent): Promise<LocationEntity | undefined> => {
  const lat = e?.latLng?.lat();
  const lng = e?.latLng?.lng();
  if (lat == null || lng == null) return;
  return getLocationFromCoordinates(lat, lng);
};